export default __webpack_public_path__ + "static/media/banner1.91a6ba70.png";